export default class FeatureFlagIds {
    static readonly REQUIRE_AUTHENTICATION = "require_authentication";
    static readonly VALUATION_BLOCKLIST = "valuation_blocklist";
}
